<template>
  <div class="isPrompt">
    <el-dialog title="提示" :visible.sync="valeu" width="30%" center>
      <span>{{ content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="valeu = false">取 消</el-button>
        <el-button type="primary" @click="valeu = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["content", "ishow"],
  data() {
    return {
      valeu: false,
    };
  },
  watch: {
    ishow(e) {
      this.valeu = e;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/isPrompt/index.vue